'use client';

import { Fragment } from 'react';

interface PurchaseTrustListProps {
	/** Trust line entries, rendered uppercase in one line with ◆ separators. */
	items: string[];
	/** Small print under the trust line (CMS microcopy, tokens already resolved). */
	subtext?: string | null;
}

/**
 * Under-CTA trust line for subscription products: "FREE FAST SHIPPING ◆
 * 30-DAY GUARANTEE ◆ CANCEL ANYTIME" with the CMS subtext underneath.
 */
export function PurchaseTrustList({ items, subtext }: PurchaseTrustListProps) {
	if (items.length === 0 && !subtext) return null;

	return (
		<div className="space-y-1.5 text-center">
			{items.length > 0 && (
				<p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10px] font-semibold uppercase tracking-wider text-neutral-700">
					{items.map((item, index) => (
						<Fragment key={item}>
							{index > 0 && (
								<span aria-hidden="true" className="text-[8px] text-neutral-300">
									◆
								</span>
							)}
							<span>{item}</span>
						</Fragment>
					))}
				</p>
			)}
			{subtext && <p className="text-[10px] leading-snug text-neutral-500">{subtext}</p>}
		</div>
	);
}
